import { render, staticRenderFns } from "./pos-salaryPaid.vue?vue&type=template&id=5c4bc1dc"
import script from "./pos-salaryPaid.vue?vue&type=script&lang=js"
export * from "./pos-salaryPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports